export default __webpack_public_path__ + "static/media/sensor_g.09cd3190.svg";